import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "Adding sound sources to a soundscape does not have to be a negative influence, even if it might increase the overall SPL. Use the buttons at the bottom to experiment with different combinations of sounds and observe how the overall character of the soundscape changes.",
  theory: theory,
  layout: {
    type: "custom022801",
    options: {
      data: {
        imageUrl: `${config.ASSETS_URL}/02/28/principle/principle-2.png`,
        scapes: {
          base: {
            audioUrl: `${config.ASSETS_URL}/02/28/principle/base.wav`,
            badgeValues: ["L = 78.07 dB(A)", "N5 = 62.51 sone"],
          },
          vehicles: {
            audioUrl: `${config.ASSETS_URL}/02/28/principle/vehicles.wav`,
            badgeValues: ["L = 80.70 dB(A)", "N5 = 69.85 sone"],
          },
          construction: {
            audioUrl: `${config.ASSETS_URL}/02/28/principle/construction.wav`,
            badgeValues: ["L = 80.64 dB(A)", "N5 = 68.49 sone"],
          },
          water: {
            audioUrl: `${config.ASSETS_URL}/02/28/principle/water.wav`,
            badgeValues: ["L = 79.73 dB(A)", "N5 = 66.03 sone"],
          },
          bird: {
            audioUrl: `${config.ASSETS_URL}/02/28/principle/birds.wav`,
            badgeValues: ["L = 79.31 dB(A)", "N5 = 63.50 sone"],
          },
        },
      },
    },
  },
};

export default principle;
